<form [formGroup]="createRelationFormGroup" (ngSubmit)="submit()">
    <section class="sh-dialog__content">
        <sh-form-multi-select
            [id]="'relation-types-select'"
            [label]="'items.create-relation-dialog.relation-type-label' | translate"
            [control]="relationTypesControl"
            [options]="relationTypeFormSelectOptions$ | async"
            [sortAlphabetically]="true"
            [limitHeightToViewport]="true"
            [inOverflownContainer]="true"
        >
        </sh-form-multi-select>

        <sh-form-multi-select
            [id]="'fragments-select'"
            [label]="fragmentsLabel | translate"
            [control]="fragmentsControl"
            [options]="fragmentsFormSelectOptions$ | async"
            [noResultsFoundMsg]="'ui.no-results-rights' | translate"
            [searchPlaceholderMsg]="'ui.search' | translate"
            [listCappedMsg]="'ui.capped-results' | translate"
            [searchPlaceholderMsg]="fragmentsSearchPlaceholder | translate"
            [search]="true"
            [limitHeightToViewport]="true"
            [inOverflownContainer]="true"
            (searchTerm)="onSearchTermChange($event)"
        >
        </sh-form-multi-select>
    </section>
    <footer class="sh-dialog__footer">
        <div class="sh-action-group -sh-align-end">
            <button type="submit" class="sh-button sh-action-group__item" [disabled]="createRelationFormGroup.invalid">{{config.data.create}}</button>
            <button type="button" class="sh-button--secondary sh-action-group__item" (click)="cancel()">{{config.data.cancel}}</button>
        </div>
    </footer>
</form>
